import { createContext, useEffect, useState } from "react";
import { getBestRole } from "../utils/general.js";

export const UserContext = createContext({
  user: null,
  setUser: () => {},
});

export const UserContextProvider = ({ children, initialUser = null }) => {
  const [user, setUser] = useState(initialUser || null);
  const [bestRole, setBestRole] = useState(null);

  useEffect(() => {
    if (user) {
      setBestRole(getBestRole(user));
    }
  }, [user]);

  return (
    <UserContext.Provider value={{ user, setUser, bestRole }}>
      {children}
    </UserContext.Provider>
  );
};
